import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { parseISO, format } from "date-fns";
import { id as localeId } from "date-fns/locale";
import { activities } from "../../data/activities";
import { outlets } from "../../data/outlets";
import type { BookingFormState } from "./useBookingForm";
import { formatIDR } from "../../utils/currency";
interface BookingConfirmationProps {
  form: BookingFormState;
  code: string;
}
export function BookingConfirmation({
  form,
  code
}: BookingConfirmationProps) {
  const activity = activities.find(a => a.id === form.activityId);
  const outlet = outlets.find(o => o.id === form.outletId);
  const isActivity = form.type === "activity" && activity;
  const rows = [{
    label: "Pesanan",
    value: isActivity ? activity.title : "Reservasi meja"
  }, {
    label: "Outlet",
    value: outlet ? `Kopi Lima Detik ${outlet.name}` : "—"
  }, {
    label: "Waktu",
    value: form.date ? `${format(parseISO(form.date), "EEEE, d MMMM", {
      locale: localeId
    })} · ${form.time}` : "—"
  }, {
    label: form.type === "activity" ? "Peserta" : "Tamu",
    value: `${form.guests} orang`
  }, ...(isActivity ? [{
    label: "Total",
    value: formatIDR(activity.price * form.guests)
  }] : [])];
  return <div className="text-center" data-id="element-46" data-mp="9uqo7cpnc1zf">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-sage text-cream" data-id="element-47" data-mp="9tfhp54tgg4m">
        <CheckIcon className="h-7 w-7" strokeWidth={2.5} data-id="element-48" data-mp="3s0wld8oo8mhc" />
      </motion.div>
      <p className="mt-5 text-base text-ink" data-id="element-49" data-mp="3n1a9p3ohrean">
        Terima kasih, {form.name.split(" ")[0]}! Pesananmu sudah dikonfirmasi.
      </p>
      <p className="mt-1 text-sm text-ink-muted" data-id="element-50" data-mp="1q75o4ijerghf">
        Konfirmasi WhatsApp sedang dikirim ke {form.phone}.
      </p>

      <div className="mt-6 rounded-card bg-white p-5 text-left ring-1 ring-cream-line" data-id="element-51" data-mp="1l7b0cnuxj70l">
        <div className="flex items-center justify-between border-b border-dashed border-cream-line pb-4" data-id="element-52" data-mp="3fob1sac8gjj2">
          <span className="text-xs text-ink-muted" data-id="element-53" data-mp="3khnh1tv0vdz5">Kode pesanan</span>
          <span className="font-mono text-base font-semibold tracking-wider text-espresso" data-id="element-54" data-mp="35sr87ul55wxh">{code}</span>
        </div>
        <dl className="mt-3 divide-y divide-cream-line" data-id="element-55" data-mp="3ar17ag9zlhod">
          {rows.map(r => <div key={r.label} className="flex justify-between gap-4 py-2.5 text-sm" data-id="element-56" data-mp="2c0usun8chlr">
              <dt className="text-ink-muted" data-id="element-57" data-mp="78rdlpqf5rav">{r.label}</dt>
              <dd className="text-right font-medium text-ink" data-id="element-58" data-mp="3ohxu1qh8f4ni">{r.value}</dd>
            </div>)}
        </dl>
      </div>
      <p className="mt-4 text-xs text-ink-muted" data-id="element-59" data-mp="3tg7pm26vc79n">Tunjukkan kode ini di kasir. Bayar di tempat.</p>
    </div>;
}